/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { Epic, ofType } from 'redux-observable';
import {
    AlertsSettingsAction,
    AlertsSettingsActionType,
    fetchAlertsTemplatesSuccessAction,
    alertsSettingsNotificationAction,
    updateAlertTemplateSuccess,
    setLoadingAction,
} from '../actions/alertsSettingsActions';
import { RootState } from '../store.typings';
import { catchError, map, switchMap, takeUntil } from 'rxjs/operators';
import { AlertsSettingsState } from '../reducers/alertsSettingsReducer';
import { from, of, concat } from 'rxjs';
import { alertsClient } from '../api/alerts/alertsClient';
import { TemplatesListSearchParams } from '../api/alerts/alertsClient.typings';
import { AxiosError } from 'axios';
import { parseError } from '../../utils/utils';

type AlertsTemplatesEpic = Epic<AlertsSettingsAction, AlertsSettingsAction, RootState>;

export const fetchAlertsTemplatesEpic: AlertsTemplatesEpic = (action$, state$) => {
    return action$.pipe(
        ofType(
            AlertsSettingsActionType.OPEN_ALERTS_SETTINGS_PAGE,
            AlertsSettingsActionType.CHANGE_ALERTS_TEMPLATES_SEARCH_PARAMS,
        ),
        switchMap(() => {
            const state = state$.value.alertsSettingsReducer;
            const searchParams = getSearchParamsFromState(state);

            return concat(
                of(setLoadingAction()),
                from(alertsClient.getTemplates(searchParams)).pipe(
                    map((list) => fetchAlertsTemplatesSuccessAction(list)),

                    catchError((err: AxiosError) => of(alertsSettingsNotificationAction(parseError(err)))),

                    takeUntil(action$.ofType(AlertsSettingsActionType.EXIT_ALERTS_SETTINGS_PAGE)),
                ),
            );
        }),
    );
};

export const updateAlertTemplateEpic: AlertsTemplatesEpic = (action$) => {
    return action$.pipe(
        ofType(AlertsSettingsActionType.UPDATE_ALERT_TEMPLATE),
        switchMap((action) => {
            return concat(
                of(setLoadingAction()),
                from(alertsClient.updateAlertTemplate(action.payload)).pipe(
                    map((template) => updateAlertTemplateSuccess(template)),

                    catchError((err: AxiosError) => of(alertsSettingsNotificationAction(parseError(err)))),
                ),
            );
        }),
    );
};

function getSearchParamsFromState(state: AlertsSettingsState): TemplatesListSearchParams {
    return {
        offset: state.templatesListSearchParams.offset,
        limit: state.templatesListSearchParams.limit,
    };
}
